<template>
  <div class="main_body submission_page">
    <section id="hero_section">
      <div class="container">
        <navbar></navbar>
        <div class="main_logo">
          <img src="@/assets/images/Logo-011.png" alt="Logo-011.png">
        </div>
        <section class="contact_section">
          <div class="heading_section">
            <h3>Submit to GM Nanashi's Playlist</h3>
            <!-- <h5>
              All questions related to Good Morning Nanashi can be submitted down below.
              <br>
              <span>Please Note - Questions will be answered in the order received.</span>
            </h5> -->
          </div>
          <div class="rules px-3 mb-4">
            <h3 class="mb-3"><u>Stream Lofi</u></h3>
            <div class="mt-2">
              <ul>
                <li>Paid Submissions via Ko-fi</li>
                <li>One month submission</li>
                <li>24 hour response via <b class="font-serif">KO-FI</b>
                  <a href="https://gmnanashi.ffm.to/kofi.OWE" target="_blank">(Here)</a>
                  <br>
                  *All earnings and support will help!
                </li>
              </ul>
            </div>

            <h5 class="mb-2"><u>Complimentary Submissions [Action Required]</u></h5>
            <ul>
              <li>𝙊𝙉𝙀 𝙎𝙊𝙉𝙂 𝙋𝙀𝙍 𝙎𝙐𝘽𝙈𝙄𝙎𝙎𝙄𝙊𝙉</li>
              <li>1 week submission</li>
              <li>Track must not exceed 3 minutes</li>
              <li>Results will be delivered via EMAIL</li>
              <li>Follow us for updates</li>
              <li>Submissions open only when our Twitter post is live</li>
            </ul>
            <div>
              <a class="redirect-link" href="https://gmnanashi.ffm.to/twitter.OWE" target="_blank">X-TWITTER</a>
              &ensp;
              <a class="redirect-link" href="https://gmnanashimusic.com/instagram.OWE" target="_blank">INSTAGRAM</a>
              &ensp;
              <a class="redirect-link" href="https://gmnanashimusic.com/gmnanashishop.OWE" target="_blank">MERCH</a>
              &ensp;
              <a class="redirect-link"
                href="https://gmnanashimusic.com/submission.OWE" target="_blank">STREAM LOFI</a>
              &ensp;
              <a href="https://gmnanashi.ffm.to/artist.OWE" target="_blank" class="redirect-link">ARTIST PROFILE</a>
            </div>
          </div>

          <div class="row" v-if="$store.getters.isLoggedIn">
            <div class="form_wrapper">
              <form @submit.prevent="submit">
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-3 pt-3">
                      <label class="text-white font-weight-bold mb-0" for="name">Artist Name</label>
                      <br>
                      <small>(Spotify)</small>
                    </div>
                    <div class="col-md-9">
                      <input type="text" class="form-control" required id="name" v-model="form.artist_name"
                        placeholder="Artist Name" name="name">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-3 pt-3">
                      <label class="text-white font-weight-bold mb-0" for="name">Username</label>
                      <br>
                      <small>(Twitter or IG)</small>
                    </div>
                    <div class="col-md-9">
                      <input type="text" class="form-control" required id="name" v-model="form.social_username"
                        placeholder="Username" name="name">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-3 pt-3">
                      <label class="text-white font-weight-bold mb-0" for="email">Spotify URL</label>
                      <br>
                      <small>(1 Track Only)</small>
                    </div>
                    <div class="col-md-9">
                      <input type="text" class="form-control" required id="email" v-model="form.spotify_url"
                        placeholder="Spotify URL" name="email">
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-3 pt-3">
                  </div>
                  <div class="col-md-9">
                    <captcha :key="captcha.restart" :captcha="captcha"></captcha>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-3 pt-3">
                  </div>
                  <div class="col-md-9">
                    <button type="submit" :disabled="this.$store.getters.apiStatus === 'loading'"
                      class="btn btn_submit">
                      <div v-if="this.$store.getters.apiStatus !== 'loading'">Submit</div>
                      <div v-else class="loader">
                        <Loader></Loader>
                      </div>
                    </button>
                  </div>
                </div>

              </form>
            </div>

          </div>

          <div v-else>
             <div class="rules px-3 mb-5">
              <p>Before submitting your track, please either create an account or log in.</p>
              <div>
              <router-link class="redirect-link auth" to="/login">Login</router-link>
              &ensp;
              <router-link class="redirect-link auth" to="/signup">Signup</router-link>
            </div>
            </div>
          </div>
        </section>
      </div>
    </section>

    <also-available-on />

    <!-- middle section ends -->
    <section class="bottom_bg_wrapper">
      <twitter-feed />
      <div class="container">
        <social-links />
      </div>
      <!-- <instagram-feed></instagram-feed> -->
    </section>
  </div>
</template>

<script>
// import InstagramFeed from '../components/InstagramFeed.vue'
import Navbar from '../components/Navbar.vue'
import Captcha from '../components/Captcha.vue'
import SocialLinks from '../components/SocialLinks.vue'
import TwitterFeed from '../components/TwitterFeed.vue'
import AlsoAvailableOn from '../components/AlsoAvailableOn.vue'

export default {
  components: {
    Navbar,
    Captcha,
    SocialLinks,
    TwitterFeed,
    AlsoAvailableOn
  },
  name: 'Submission',
  data () {
    return {
      captcha: {
        recaptchaVerified: false,
        value: null,
        restart: false
      },
      form: {
        artist_name: '',
        social_username: '',
        spotify_url: ''
      }
    }
  },
  mounted () {
    if (this.$store.getters.isLoggedIn) { this.$store.dispatch('isUserLoggedIn') }
  },
  methods: {
    submit () {
      if (!this.captcha.recaptchaVerified) {
        this.$toast.error('Please verify captcha!')
        return
      }
      this.form['g-recaptcha-response'] = this.captcha.value
      this.$store
        .dispatch('submitSubmission', this.form)
        .then(() => {
          this.$router.push('/')
          this.$toast.success('Your submission request has been submitted.')
        })
        .catch((err) => {
          this.captcha.restart = !this.captcha.restart
          this.captcha.recaptchaVerified = false
          this.captcha.value = null

          this.$helper.catchHandler(err)
        })
    }
  }
}

</script>

<style scoped>
  .btn_submit {
    min-width: 189px;
    min-height: 50px;
  }

  .btn_submit:disabled {
    opacity: 1;
  }

  .rules {
    line-height: 20px;
  }

  li {
    margin-left: 1.3rem;
  }

  li::marker {
    content: '➤ ';
  }

  .redirect-link {
    color: yellow;
    text-decoration: underline;
  }

  .auth {
    color: #9cf80e;
    font-size: 18px;
  }

  small {
    color: #ef2025
  }

  .font-serif {
    font-family: sans-serif;
  }

</style>



// WEBPACK FOOTER //
// src/views/Submission.vue